<template>
  <div class="navAssembly-nav" id="navId">
    <div class="navAssembly-navInner">
      <span
        v-for="(item, index) in navList"
        :key="index"
        :class="{ navActive: navShow == index }"
        @click="navClick(item, index)"
        >{{ item.name }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "navAssembly",
  props: {
    navList: {
      type: Array
    }
  },
  data() {
    return {
      navShow: 0
    };
  },
  watch: {
    navList(val) {
      // console.log(val);
    }
  },
  created() {
    this.getScroll();
    // console.log(document.getElementById("navId").scrollTop);
  },
  methods: {
    navClick(item, index) {
      this.navShow = index;
      location.href = item.url;
      document.documentElement.scrollTop -= 140;
    },
    getScroll() {
      window.onscroll = function() {
        //变量t是滚动条滚动时，距离顶部的距离
        var t = document.documentElement.scrollTop || document.body.scrollTop;
        var scrollup = document.getElementById("navId");
        if (scrollup) {
          if (t > 800) {
            scrollup.style.cssText = "position: fixed;top: 0; ";
          } else {
            scrollup.style.cssText = "position: relative;top: unset;";
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.navAssembly-nav {
  width: 1920px;
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 6px 14px 0px rgba(89, 98, 107, 0.08);

  z-index: 9999;
}
.navAssembly-navInner {
  width: 1280px;
  margin: 0 auto;
  line-height: 68px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  padding: 0 47px;
}
.navAssembly-navInner span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  cursor: pointer;
}
.navAssembly-navInner .navActive {
  border-bottom: 3px solid #df3a3a;
  color: #df3a3a;
}
</style>



// WEBPACK FOOTER //
// src/components/NavAssembly.vue